import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import { connect } from 'react-redux'
import { CSSProperties } from 'react'
import AddressAutoComplete from '../Components/AddressAutoComplete';
import { Diamonds } from '../Components/Diamonds'
import { ProofCard } from '../Components/ProofCard'
import { browserHistory } from 'react-router'
import * as Request from '../tgccRequest'
import AddressAutocomplete from '../Components/AddressAutoComplete'
import {
    CedOrderProcessing,
    CedOrderConfirmation,
    CedFieldPowerMeter,
    CedBreakerSizeCard,
    CedPickTicket,
    CedCheckoutShell,
    CED_PICKED_STAMP_MS,
    CED_MIN_PROCESSING_MS,
} from './CedOrderFx'


const mobileBreakpoint = '@media (max-width: 768px)';

const wrapperStyle: React.CSSProperties = {
    backgroundColor: 'white',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    color: Tgcc.Styles.darkTextColor,
    fontSize: '13px',
    padding: '25px',
    width: '450px',
    maxWidth: '80%',
    borderRadius: '20px',
    marginBottom: '20px'
}

const additionalCostStyle: React.CSSProperties = {
    textAlign: 'center',
    fontSize: '12px',
    color: '#D47C61', // Match the shipHighlightColor for consistency
    marginTop: '5px',
};

const rowStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    height: '35px',
}

const inputFieldStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    padding: '10px 15px',
    border: '1px solid #ccc',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '2vh',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
    fontSize: '16px',
    color: '#333',
    outline: 'none',
    transition: 'border-color 0.3s, box-shadow 0.3s',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    // Remove the hover and focus styles if you want to revert to the previous simple style
};



let szRowStyle = Object.assign({}, rowStyle, { margin: "0 30px" });

const labelStyle: React.CSSProperties = {
    fontWeight: 'bold',
    marginBottom: '5px',
    display: 'block', // Ensures label is on its own line
    color: '#333',
    fontSize: '16px',
};
let szLblStyle = Object.assign({}, labelStyle, { flexBasis: '90px', justifyContent: 'flex-end', marginRight: '3px', fontFamily: 'Reitam' });
const szDivider = Object.assign({}, labelStyle, { flexBasis: '30px' });

const inputStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    backgroundColor: 'white',
    lineHeight: '18px',
    height: '18px',
    width: '100px',
    marginLeft: '3px',
    padding: '2px',
    fontSize: '13px',
    display: 'flex',
    flexShrink: 1,
    flexGrow: 1,
    border: '1px solid #E9E6E6'
}

const sizeOptionContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '20px',
};

const sizeOptionStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '90%', // Adjust based on your layout preference
    margin: '10px 0',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#f4f4f4',
};

const sectionSizeContainer: React.CSSProperties = {
    width: '900px',
};




let orgLblStyle = { flexBasis: '110px' };
let nameLblStyle = { flexBasis: '90px', fontFamily: 'Lulo' };
let emailLblStyle = { flexBasis: '70px', fontFamily: 'Lulo' };
let orgStyle = Object.assign({}, inputStyle, { flexBasis: '220px' });
let nameStyle = Object.assign({}, inputStyle, { flexBasis: '140px', fontFamily: 'BarlowLight' });
let emailStyle = Object.assign({}, inputStyle, { flexBasis: '310px', fontFamily: 'BarlowLight' });
let numberStyle = Object.assign({}, inputStyle, { width: '40px', textAlign: 'right', marginRight: "10px", fontFamily: 'BarlowLight' })
let addrlineStyle = Object.assign({}, inputStyle, { width: '317px', marginRight: "10px", fontFamily: 'BarlowLight' });
let cityStyle = Object.assign({}, inputStyle, { width: '160px', marginRight: "10px", fontFamily: 'BarlowLight' });
let stateStyle = Object.assign({}, inputStyle, { width: '40px', maxlength: 2, marginRight: "10px", fontFamily: 'BarlowLight' });
let zipStyle = Object.assign({}, inputStyle, { width: '65px', maxlength: 10, marginRight: "10px", fontFamily: 'BarlowLight' });
let hdrStyle = Object.assign({}, labelStyle, { fontSize: '16px', fontWeight: 'bold', display: 'block', textAlign: "center", marginBottom: '10px' });
let checkLabelStyle = Object.assign({}, labelStyle, { fontWeight: 'normal', letterSpacing: '1.2px', fontSize: '12px', textAlign: "center", flexShrink: 'none', flexGrow: 'none' });
let checkRowStyle = Object.assign({}, rowStyle, { flexGrow: 'none', justifyContent: 'space-around' })
let errorStyle = Object.assign({}, Tgcc.Styles.error, { fontSize: '13px', maxWidth:'50%', padding: '0 10px' });

const shipCheckStyle: React.CSSProperties = {
    display: 'flex',
    lineHeight: '22px',
    height: '15px',
    width: '15px',
    alignSelf: 'baseline'
}
const hrStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    width: '85%',
    margin: '15px 0'
}

const thanksStyle: React.CSSProperties = {
    height: '45px',
    lineHeight: '45px',
    fontSize: '40px',
    fontFamily: 'BarlowMedium',
    textTransform: 'none',
    textAlign: 'center',
    marginBottom: '20px',
};

const orderBtn: React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0px 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0px',
}

const closedBtn: React.CSSProperties = {
    display: 'table',
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Lulo',
    fontSize: '28px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    background: '#E27558',
    padding: '5px 40px',
    margin: '5px auto 10px',
    cursor: 'pointer',
}

const proseStyle: React.CSSProperties = {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    margin: '45px auto 0px auto',
    width: '90%',
    fontFamily: 'BarlowMedium',
    textTransform: 'none',
    textAlign: 'center',
    padding: '0 10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}

const shipHighlightColor: string = '#D47C61';
const NAVY_CED = '#1a365d';

const shipHdrStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: 'bold',
    letterSpacing: '2.8px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: shipHighlightColor,
    marginBottom: '10px'
}

const inlineHighlightAllCaps: React.CSSProperties = {
    color: shipHighlightColor,
    textTransform: 'uppercase'
}
const inlineHighlightAllCapsBold: React.CSSProperties = {
    color: shipHighlightColor,
    textTransform: 'uppercase',
    fontWeight: 'bold'
}
const inlineHighlightBold: React.CSSProperties = {
    fontWeight: 'bold',
    textTransform: 'uppercase'
}

const checkoutContainer: React.CSSProperties = {
    backgroundColor: 'rgb(244, 250, 255)',
    fontFamily: 'CenturyGothic',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    color: Tgcc.Styles.darkTextColor,
    fontSize: '13px',
    padding: '5px',
    width: '100%',
    borderRadius: '20px',
    [mobileBreakpoint]: {
        borderRadius: '10px', // Optional: reduce border radius on mobile
        maxWidth: '100%',
        width: '100%',
      },
}



const userInfoRowStyle: React.CSSProperties = {
    margin: '20px 0px', // Adjust the space between each row
    display: 'flex',
    alignItems: 'center', // Center the items horizontally
    width: '100%', // Ensure it spans the width of its container
}

const headerStyle: React.CSSProperties = {
    color: '#fff', // Assuming white text color from the image
    textAlign: 'center',
    fontSize: '2em', // Adjust the font size as needed
    textTransform: 'math-auto',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    fontWeight: 'bold',
    marginBottom: '0.5em', // Spacing below the header
  };
  
  const subheaderStyle: React.CSSProperties = {
    color: '#ddd', // Lighter color for the subheader, adjust as needed
    textAlign: 'center',
    fontSize: '1em',
    padding: '20px',
    textTransform: 'math-auto',
    fontFamily: '"RocknRoll One", sans-serif', // And here
    marginBottom: '2em', // More spacing below the subheader to separate from the form
    maxWidth: '600px', // Ensuring the subheader does not span too wide
    marginRight: 'auto',
    marginLeft: 'auto',
  };

const userInfoContainer: React.CSSProperties = {
    backgroundColor: 'rgb(24, 17, 71)',
    width: '100%', // This makes the background color extend full width
    padding: '50px 0px',
    marginTop: '40px',
    [mobileBreakpoint]: {
        padding: '30px 10px', // Adjust padding for mobile
      },

};

const userInfoContent: React.CSSProperties = {
    maxWidth: '70%',
    marginRight: 'auto',
    marginLeft: 'auto',
    [mobileBreakpoint]: {
        maxWidth: '90%', // Increase max-width for mobile
      },
};

const userInfoInputStyle: React.CSSProperties = {
    width: '40%', // As per your request, adjust if necessary
    padding: '10px 15px', // Provide ample padding for the input
    margin: '0 auto', // Center the input within the row
    border: '1px solid #ccc', // A light border as per standard input style, adjust as necessary
    borderRadius: '4px', // Optional, if you want rounded corners
    fontSize: '16px', // Match the font size to your label for consistency
    color: 'black', // Input text color, assuming it should be black for visibility
    background: 'white', // Assuming a white background for input fields
}

const sizeCardStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '15px 20px',
    margin: '10px 0',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    transition: 'box-shadow 0.3s ease-in-out',
    backgroundColor: '#fff',
};

const sizeRowStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-around', // This will space your cards evenly
    backgroundColor: 'white',
    flexWrap: 'wrap', // This allows cards to wrap to the next line
    margin: '0 -15px', // Adjust margins as necessary
};

const sizeCardContainerStyle: React.CSSProperties = {
    boxSizing: 'border-box',
    padding: '10px', // Reduced padding
    width: 'calc(33.333% - 20px)', // Adjusted for 3 cards per row with padding
    marginBottom: '20px', // Reduced space between rows of cards
};

const updatedSizeCardStyle: React.CSSProperties = {
    ...sizeCardStyle, // Keep the original styles
    height: '80px', // Reduced height for a more compact card
    padding: '10px', // Reduced padding within the card
};


const sizeLabelStyle: React.CSSProperties = {
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#333', // Or any color that fits your design
};

const inputNumberStyle: React.CSSProperties = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '10px',
    width: '60px',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    outline: 'none',
    marginRight: '5px',
};

const sizeHeaderStyle: React.CSSProperties = {
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    margin: '20px 0',
    color: '#333', // Or any color that fits your design
};

const addressesContainer: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '0 10px',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
}

const popupBackgroundStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const popupStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    maxWidth: '500px',
    width: '90%',
};

const closeButtonStyle: React.CSSProperties = {
    marginTop: '20px',
    padding: '10px 20px',
    backgroundColor: '#E27558',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
};

const imageStyle: React.CSSProperties = {
    display: 'block',
    margin: '0 auto 20px auto',
    width: '100px', // Adjust the width as needed
    height: '100px', // Adjust the height as needed
};

const ThankYouPopup = ({ onClose, specialWebstore, catalogUrl }) => {
    if (specialWebstore === 'CED') {
        return <CedOrderConfirmation onClose={onClose} catalogUrl={catalogUrl} />;
    }

    return (
    <div style={popupBackgroundStyle}>
        <div style={popupStyle}>
            <h2>Thank you for your order!</h2>
            <p>
                {specialWebstore === 'PapaJohns'
                    ? 'Your order has successfully been placed, we appreciate your business! Please check your email for a confirmation of your order.'
                    : 'Your order has been successfully placed. We appreciate your business and will follow up with you shortly!'}
            </p>
            <img src={Tgcc.ResolveUrl('~/images/TviteConfirmationImage.png')} style={imageStyle} alt="Thank you" />
            <button style={closeButtonStyle} onClick={onClose}>Close</button>
        </div>
    </div>
    );
};



class Props {
    tvite: Tgcc.TviteInfo;
    purchaseComplete: boolean;
}

interface SizeCardProps {
    size: string;
    value: number;
    onChange: (evt: React.FormEvent<HTMLInputElement>) => void;
    disabled: boolean;
    style?: React.CSSProperties;
    displayLabel: string;
    specialWebstore?: string; // Include this line
}

const SizeCard = ({ size, value, onChange, disabled, style, displayLabel, specialWebstore }: SizeCardProps) => {
    let additionalCost = null;

    // Adjust the condition to not add surcharges for HBI and sizes XXL and XXXL, and exclude 4XL entirely
    if (specialWebstore !== 'HBI') {
        if (size === 'XXL' || size === 'XXXL') {
            additionalCost = '+$2 extra';
        } else if (size === 'XXXXL' || size === 'XXXXXL') {
            additionalCost = '+$3 extra';
        }
    }

    return (
        <div style={{ ...sizeCardStyle, ...style }} id='sizeCard'>
            <div style={sizeLabelStyle}>{displayLabel}</div>
            {additionalCost && <div style={additionalCostStyle}>{additionalCost}</div>}
            <input
                type="number"
                name={size}
                value={value.toString()}
                onChange={onChange}
                disabled={disabled}
                style={inputNumberStyle}
            />
        </div>
    );
};

export class TVitePurchase extends React.Component<Props, any>{
    private cedProcessingStartedAt: number | null = null;
    private cedOrderCompleteTimer: number | null = null;

    state = {
        error: null,
        isWaiting: false,
        Organization: "",
        FirstName: "",
        LastName: "",
        Email: "",
        PhoneNumber: "",
        Small: 0,
        Medium: 0,
        Large: 0,
        XLarge: 0,
        XXL: 0,
        XXXL: 0,
        XXXXL: 0,
        XXXXXL: 0,
        YXSmall: 0,
        YSmall: 0,
        YMedium: 0,
        YLarge: 0,
        YXLarge: 0,
        payment: null,
        purchaseComplete: false,
        sizesList: null,
        individualShip: false,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        isSingleSizeItem: false,
        showThankYouPopup: false,
        cedPickedStamp: false,
        singleItemQuantity: 0,
        subheaderText: "Please fill in your information below before adding products so we know how to label your shirts and where to send you a receipt!"
    };

    componentWillMount() {
        if (this.props.tvite.proofId) {
            Request.getOneProof(this.props.tvite.proofId, this.productFound, this.loadError);
        }
    }

    componentDidMount() {
        this.setState({
            isSingleSizeItem: this.props.tvite.isSingleSizeItem
        });

        if (this.props.tvite.code === 'WO748640') {
            this.setState({
                subheaderText: "From their U.S. grown ring spun cotton construction and blends to their Clean Canvas print technology face, our Perfect-Ts are meant for more. More daring embellishments, more stylish fit and more for those with a sense of fashion (offering both solid & CVC shades).\n\nExperience the perfection by redeeming a free decorated sample!"
            });
        } else if (this.props.tvite.specialWebstore === 'CED') {
            this.setState({
                subheaderText: "Please fill in your information below for a smooth connection on your order."
            });
        }
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.tvite.isSingleSizeItem !== this.props.tvite.isSingleSizeItem) {
            this.setState({
                isSingleSizeItem: this.props.tvite.isSingleSizeItem
            });
        }
    }

    
    productFound = (proof: Tgcc.Proof) => {
        console.log(this.state.isSingleSizeItem)
        if (proof != null) {
            Request.getSizes(proof.product.brand, proof.product.style, proof.product.colorName, this.sizesFound, this.loadError);
        }
    }

    sizesFound = (products: Tgcc.Product[]) => {
        this.setState({ sizesList: products })

    }
    getSizesList = () => {
        var productSizes = new Array();
        if (this.state.sizesList) {
            for (var x in this.state.sizesList) {
                productSizes.push(this.state.sizesList[x].Size);
            }
        }
        return productSizes;
    }
    checkXSmall = () => {
        var sizeList = this.getSizesList();
        for (var y in sizeList) {
            if (sizeList[y] == "XSmall") {
                return "yes";
            }
        }
    }

    handleAddressSelect = (address) => {
        this.setState({
            address1: address.address1,
            address2: address.address2,
            city: address.city,
            state: address.state,
            zip: address.zipcode,
        }, () => this.allFieldsAreValid());
    }
    
    SizeCard = ({ size, value, onChange, disabled, style, displayLabel, specialWebstore }) => {
        let additionalCost = null;
        if (specialWebstore !== 'HBI') {
            if (size === 'XXL' || size === 'XXXL') {
                additionalCost = '+$2 extra';
            } else if (size === 'XXXXL' || size === 'XXXXXL') {
                additionalCost = '+$3 extra';
            }
        }
    
        return (
            <div style={{ ...sizeCardStyle, ...style }} id='sizeCard'>
                <div style={sizeLabelStyle}>{displayLabel}</div>
                {additionalCost && <div style={additionalCostStyle}>{additionalCost}</div>}
                <input
                    type="number"
                    name={size}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    style={inputNumberStyle}
                />
            </div>
        );
    };


    loadError = (err: any) => {
        this.setState({ sizesList: [], isWaiting: false });
        console.log("error loading tvite: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    handleFieldChange = (evt: React.FormEvent<HTMLInputElement>) => {
        const { name, value, type } = evt.currentTarget;
        let fldChange: any = {};
    
        if (type === 'number') {
            let numericValue = parseInt(value, 10);
            numericValue = isNaN(numericValue) ? 0 : numericValue;
    
            // Adjust logic for HBI, where sizes XS to 3XL are allowed and no surcharge for XXL and 3XL
            if (this.props.tvite.specialWebstore === 'HBI' && ['Small', 'Medium', 'Large', 'XLarge', 'XXL', 'XXXL'].includes(name)) {
                // Cap the newValue at 1 for HBI special case
                if (numericValue > 1) {
                    numericValue = 1;
                }
    
                // Ensure only applicable sizes are reset for HBI special case
                const resetSizesHBI = {
                    Small: 0,
                    Medium: 0,
                    Large: 0,
                    XLarge: 0,
                    XXL: 0,
                    XXXL: 0,
                    // Exclude sizes not applicable for HBI from the reset
                };
    
                fldChange = { ...resetSizesHBI, [name]: numericValue };
            } else {
                fldChange[name] = numericValue;
            }
        } else {
            fldChange[name] = value;
        }
    
        this.setState(fldChange, () => { this.allFieldsAreValid(); });
    };
    
    getTotalCount = () => {
        return this.state.Small
            + this.state.Medium
            + this.state.Large
            + this.state.XLarge
            + this.state.XXL
            + this.state.XXXL
            + this.state.XXXXL
            + this.state.XXXXXL
            + this.state.YXSmall
            + this.state.YSmall
            + this.state.YMedium
            + this.state.YLarge
            + this.state.YXLarge;
    }

    /** Extra charge beyond base unit price (CED: 2XL/3XL +$2, 4XL/5XL +$3). */
    getSizeSurchargeTotal = () => {
        if (this.props.tvite.specialWebstore !== 'CED') {
            return 0;
        }
        return (this.state.XXL * 2)
            + (this.state.XXXL * 2)
            + (this.state.XXXXL * 3)
            + (this.state.XXXXXL * 3);
    }

    /** Selected size lines for CED pick-ticket summary. */
    getCedPickLines = () => {
        if (this.state.isSingleSizeItem && this.state.singleItemQuantity > 0) {
            return [{ label: 'One Size', qty: this.state.singleItemQuantity as number }];
        }
        const catalog: { key: string; label: string }[] = [
            { key: 'Small', label: 'Small' },
            { key: 'Medium', label: 'Medium' },
            { key: 'Large', label: 'Large' },
            { key: 'XLarge', label: 'XLarge' },
            { key: 'XXL', label: '2XLarge' },
            { key: 'XXXL', label: '3XLarge' },
            { key: 'XXXXL', label: '4XLarge' },
            { key: 'XXXXXL', label: '5XLarge' },
            { key: 'YXSmall', label: 'Youth XS' },
            { key: 'YSmall', label: 'Youth S' },
            { key: 'YMedium', label: 'Youth M' },
            { key: 'YLarge', label: 'Youth L' },
            { key: 'YXLarge', label: 'Youth XL' },
        ];
        return catalog
            .filter((s) => (this.state[s.key] || 0) > 0)
            .map((s) => ({ label: s.label, qty: this.state[s.key] as number }));
    }

    countsAreNegative = () => {
        return this.state.Small < 0
            || this.state.Medium < 0
            || this.state.Large < 0
            || this.state.XLarge < 0
            || this.state.XXL < 0
            || this.state.XXXL < 0
            || this.state.XXXXL < 0
            || this.state.XXXXXL < 0
            || this.state.YXSmall < 0
            || this.state.YSmall < 0
            || this.state.YMedium < 0
            || this.state.YLarge < 0
            || this.state.YXLarge < 0;
    }

    emailIsValid = () => {
        return Tgcc.IsValidEmail(this.state.Email);
    }

    isBlank = (value: any) => !value || !String(value).trim();

    /** CED (and individual-ship paths) always need a deliverable address. */
    requiresShippingAddress = () => {
        const { specialWebstore, shipType } = this.props.tvite;
        if (specialWebstore === 'CED' || specialWebstore === 'PapaJohns') {
            return true;
        }
        if (shipType === Tgcc.ShipmentTypes.Individual) {
            return true;
        }
        if (shipType === Tgcc.ShipmentTypes.Select && this.state.individualShip) {
            return true;
        }
        return false;
    }

    allFieldsAreValid = () => {
        // For WO773171 and WO773246, always consider quantity as 1
        var total;
        if (this.props.tvite.proofId === 'WO773171' || this.props.tvite.proofId === 'WO773246') {
            total = 1; // Always 1 for these weborders
        } else {
            // Adjust total based on whether it's a single size item or not
            total = this.state.isSingleSizeItem ? this.state.singleItemQuantity : this.getTotalCount();
        }
    
        if (this.countsAreNegative())
            this.setState({ error: 'Negative item count is not valid.', isWaiting: false });
    
        else if (total < 1) // This now correctly accounts for single size items
            this.setState({ error: 'Please indicate at least one size to order.', isWaiting: false });
    
        else if (this.isBlank(this.state.FirstName))
            this.setState({ error: 'First name is required.', isWaiting: false });
    
        else if (this.isBlank(this.state.LastName))
            this.setState({ error: 'Last name is required.', isWaiting: false });
    
        else if (this.isBlank(this.state.Email) || !this.emailIsValid())
            this.setState({ error: 'A valid email address is required.', isWaiting: false });
    
        else if (this.props.tvite.specialWebstore === 'CED' && this.isBlank(this.state.Organization))
            this.setState({ error: 'CED Location is required.', isWaiting: false });

        else if (this.props.tvite.code === 'WO748640' && this.isBlank(this.state.Organization))
            this.setState({ error: 'Company cannot be blank.', isWaiting: false });

        else if (this.requiresShippingAddress() && this.isBlank(this.state.address1))
            this.setState({ error: 'Address Line 1 is required.', isWaiting: false });

        else if (this.requiresShippingAddress() && this.isBlank(this.state.city))
            this.setState({ error: 'City is required.', isWaiting: false });

        else if (this.requiresShippingAddress() && this.isBlank(this.state.state))
            this.setState({ error: 'State is required.', isWaiting: false });

        else if (this.requiresShippingAddress() && this.isBlank(this.state.zip))
            this.setState({ error: 'Zip code is required.', isWaiting: false });
    
        else {
            this.setState({ error: null });
            return true;
        }
        return false;
    }
    

    getSizes = () => {
        var sizes = new Tgcc.SizesRec;
        sizes.Small = this.state.Small;
        sizes.Medium = this.state.Medium;
        sizes.Large = this.state.Large;
        sizes.XLarge = this.state.XLarge;
        sizes.XXL = this.state.XXL;
        sizes.XXXL = this.state.XXXL;
        sizes.XXXXL = this.state.XXXXL;
        sizes.XXXXXL = this.state.XXXXXL;
        sizes.YXSmall = this.state.YXSmall;
        sizes.YSmall = this.state.YSmall;
        sizes.YMedium = this.state.YMedium;
        sizes.YLarge = this.state.YLarge;
        sizes.YXLarge = this.state.YXLarge;
        return sizes;
    }

    disableEdits = () => {
        if (this.props.purchaseComplete || this.state.purchaseComplete) {
            var inputs = document.getElementsByTagName("input");
            for (var i = 0; i < inputs.length; i++)
                inputs[i].setAttribute('disabled', 'disabled');
        }
    }

    buyNow = () => {
        if (this.state.isWaiting || this.state.cedPickedStamp || this.state.purchaseComplete || this.props.purchaseComplete) {
            return;
        }
        if (!this.allFieldsAreValid()) {
            return;
        }

        const sizes = this.getSizes(); // Assuming this method properly returns all the sizes
        const { isSingleSizeItem, singleItemQuantity, Organization, FirstName, LastName, Email, PhoneNumber, individualShip, address1, address2, city, state, zip } = this.state;
        const { code, proofId, shipType } = this.props.tvite;
        
        // For WO773171 and WO773246, always set quantity to 1
        let quantity, oneSizeQuantity;
        if (this.props.tvite.proofId === 'WO773171' || this.props.tvite.proofId === 'WO773246') {
            quantity = 1;
            oneSizeQuantity = 1;
        } else {
            quantity = isSingleSizeItem ? singleItemQuantity : this.getTotalCount();
            oneSizeQuantity = isSingleSizeItem ? singleItemQuantity : 0;
        }

        const needsIndividualShip = this.props.tvite.specialWebstore === 'CED'
            || individualShip
            || shipType === Tgcc.ShipmentTypes.Individual;

        const submitOrder = () => {
            if (this.props.tvite.specialWebstore === 'CED') {
                this.cedProcessingStartedAt = Date.now();
            }
            this.setState({ isWaiting: true, error: null });
            Request.orderTvite({
                tvCode: code,
                proofId: proofId,
                organization: Organization || '', // Pass empty string if Organization is undefined or null
                firstName: FirstName,
                lastName: LastName,
                email: Email,
                phoneNumber: PhoneNumber, // Add this line
                quantity,
                individualShip: needsIndividualShip,
                addr1: address1,
                addr2: address2,
                city,
                state,
                zip,
                ...sizes,
                oneSizeQuantity,
                onSuccess: this.orderComplete,
                onError: this.orderFailed,
            });
        };

        // CED: pick-ticket “PICKED” stamp, then energizing / API wait (minimum visible processing time)
        if (this.props.tvite.specialWebstore === 'CED') {
            const reduceMotion = typeof window !== 'undefined'
                && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.setState({ cedPickedStamp: true, error: null });
            if (reduceMotion) {
                submitOrder();
            } else {
                window.setTimeout(submitOrder, CED_PICKED_STAMP_MS);
            }
            return;
        }

        submitOrder();
    };
    
    orderComplete = () => {
        if (this.props.tvite.specialWebstore === 'CED' && this.cedProcessingStartedAt != null) {
            const elapsed = Date.now() - this.cedProcessingStartedAt;
            const remaining = CED_MIN_PROCESSING_MS - elapsed;
            if (remaining > 0) {
                this.cedOrderCompleteTimer = window.setTimeout(this.finishOrderSuccess, remaining);
                return;
            }
        }
        this.finishOrderSuccess();
    };

    finishOrderSuccess = () => {
        this.cedProcessingStartedAt = null;
        if (this.cedOrderCompleteTimer != null) {
            window.clearTimeout(this.cedOrderCompleteTimer);
            this.cedOrderCompleteTimer = null;
        }
        this.setState({
            purchaseComplete: true,
            isWaiting: false,
            cedPickedStamp: false,
            showThankYouPopup: true,
        });
    };
    
    closeThankYouPopup = () => {
        this.setState({ showThankYouPopup: false });
    };
    
    
        
    freeShipContent = () => {
        const { specialWebstore, code, proofId } = this.props.tvite;
        const isBrandwear = code === 'WO748640' || proofId === 'WO748640';

        let body;
        if (isBrandwear) {
            body = (
                <div>
                    All apparel ordered will be fulfilled through <strong>INDIVIDUAL SHIPPING</strong> directly to you. Once your order has been placed, no changes to the address submitted can be made.<br /><br />
                    Individually shipped orders will be shipped out within <strong>7-10 business days</strong> after the link has been closed.<br /><br />
                    If you have any questions or concerns, fill out this form and a representative will be in touch with you.
                    <br /><br />
                    <a href="https://www.brandwearunited.com/contact" style={{ color: '#0000EE', textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">https://www.brandwearunited.com/contact</a>
                </div>
            );
        } else if (specialWebstore === 'CED') {
            body = (
                <div>
                    Your CED apparel order will ship to the address you provide below. Please double-check it before submitting — address changes cannot be made after the order is placed.<br /><br />
                    <strong>What happens next:</strong> After you place your order, you&apos;ll get a confirmation email. We fulfill and typically ship within <strong>7-10 business days</strong>. When your order ships, we&apos;ll send a QuickBooks Online invoice so you can pay online.<br /><br />
                    Questions? Contact us at 1-800-472-3269 or <a href="mailto:sales@grafcow.com" style={{ color: '#0000EE', textDecoration: 'underline' }}>sales@grafcow.com</a>.
                </div>
            );
        } else {
            body = (
                <div>
                    All apparel ordered will be fulfilled through <strong>INDIVIDUAL SHIPPING</strong> directly to you. Once your order has been placed, no changes to the address submitted can be made.<br /><br />
                    Individually shipped orders will be shipped out within <strong>7-10 business days</strong> after the link has been closed.<br /><br />
                    Please contact us at 1-800-472-3269 for any questions.
                </div>
            );
        }

        return (
            <div style={proseStyle}>
                <div style={shipHdrStyle}>{specialWebstore === 'CED' ? 'Shipping Information' : 'Bulk Shipping'}</div>
                {body}
            </div>
        )
    }

    directShipContent = () => {
        const editDisabled = this.props.purchaseComplete || this.state.purchaseComplete;
        const { specialWebstore, code, proofId } = this.props.tvite;
        const isBrandwear = code === 'WO748640' || proofId === 'WO748640';
    
        let shippingInfoContent;
    
        if (isBrandwear) {
            shippingInfoContent = (
                <div>
                    All apparel ordered will be fulfilled through <strong>INDIVIDUAL SHIPPING</strong> directly to you. Once your order has been placed, no changes to the address submitted can be made.<br /><br />
                    Individually shipped orders will be shipped out within <strong>7-10 business days</strong> after the link has been closed.<br /><br />
                    If you have any questions or concerns, fill out this form and a representative will be in touch with you.
                    <br /><br />
                    <a href="https://www.brandwearunited.com/contact" style={{ color: '#0000EE', textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">https://www.brandwearunited.com/contact</a>
                </div>
            );
        } else if (specialWebstore === 'HBI') {
            shippingInfoContent = (
                <div>
                    All apparel ordered will be fulfilled through <strong>INDIVIDUAL SHIPPING</strong> directly to you. Once your order has been placed, no changes to the address submitted can be made.<br /><br />
                    Individually shipped orders will be shipped out within <strong>7-10 business days</strong> after the link has been closed.<br /><br />
                    If you have any questions or concerns, please contact your{' '}
                    <a 
                        href="https://cdn.shopify.com/s/files/1/0874/6942/4942/files/Sales_Map_Updateds_091125.png?v=1757693092" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#0000EE', textDecoration: 'underline' }}
                    >
                        local Hanes Printwear Sales Representative.
                    </a>
                </div>
            )
        } else if (specialWebstore === 'PapaJohns') {
            shippingInfoContent = (
                <div>
                    Your order will be shipped directly to your individual franchise or store location. Please ensure the shipping address provided is accurate, as changes cannot be made once the order is finalized.<br /><br />
                    Orders ship on the <strong>20th of every month</strong>. Please make sure your order is placed well in advance.<br /><br />
                    For any inquiries or further assistance, feel free to contact us at 1-800-472-3269.
                </div>
            );
        } else if (specialWebstore === 'CED') {
            shippingInfoContent = (
                <div>
                    Your CED apparel order will ship to the address you provide below. Please double-check it before submitting — address changes cannot be made after the order is placed.<br /><br />
                    <strong>What happens next:</strong> After you place your order, you&apos;ll get a confirmation email. We fulfill and typically ship within <strong>7-10 business days</strong>. When your order ships, we&apos;ll send a QuickBooks Online invoice so you can pay online.<br /><br />
                    Questions? Contact us at 1-800-472-3269 or <a href="mailto:sales@grafcow.com" style={{ color: '#0000EE', textDecoration: 'underline' }}>sales@grafcow.com</a>.
                </div>
            );
        } else {
            shippingInfoContent = (
                <div>
                    All apparel ordered will be fulfilled through <strong>INDIVIDUAL SHIPPING</strong> directly to you. Once your order is placed, no changes to the address can be made.<br /><br />
                    Individually shipped orders typically ship within <strong>7-10 business days</strong> after the purchase link closes.<br /><br />
                    Please contact us at 1-800-472-3269 for any questions.
                </div>
            );
        }

        const shippingTitle = specialWebstore === 'PapaJohns'
            ? "Papa John's Monthly Shipping Details"
            : specialWebstore === 'CED'
                ? 'CED Shipping Details'
                : 'Shipping Information';
    
        return (
            <div style={{ 
                ...proseStyle, 
                backgroundColor: 'white', 
                padding: '20px', 
                borderRadius: '10px', 
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                margin: '20px auto',
                width: '90%',
            }}>
                <div style={{ ...shipHdrStyle, fontFamily: 'CenturyGothic', fontSize: '22px', color: '#2A2A72', marginBottom: '15px' }}>
                    {shippingTitle}
                </div>
                <p style={{ fontFamily: 'CenturyGothic', fontSize: '14px', color: '#333', lineHeight: '1.6', textAlign: 'center' }}>
                    {shippingInfoContent}
                </p>
                <hr style={{ ...hrStyle, margin: '20px auto', width: '90%' }} />
                <h3 id="shipping" style={{
                    fontSize: '18px',
                    marginBottom: '15px',
                }}>Shipping Address Details:</h3>
                <div style={addressesContainer} id="shippingAddress">
                    {/* Address Line 1 */}
                    <AddressAutocomplete
                        placeholder="Address Line 1 (Required)"
                        inputStyle={inputFieldStyle}
                        className="address-input"
                        onAddressSelect={this.handleAddressSelect}
                        onInputChange={(value) => this.setState({ address1: value }, () => this.allFieldsAreValid())}
                        addressValue={this.state.address1 || ''}
                    />
                    {/* Address Line 2 */}
                    <input
                        type="text"
                        placeholder="Address Line 2 (Optional)"
                        value={this.state.address2 || ''}
                        onChange={(e) => this.setState({ address2: (e.target as HTMLInputElement).value })}
                        style={inputFieldStyle}
                    />
                    {/* City */}
                    <input
                        type="text"
                        placeholder="City (Required)"
                        value={this.state.city || ''}
                        onChange={(e) => this.setState({ city: (e.target as HTMLInputElement).value }, () => this.allFieldsAreValid())}
                        style={inputFieldStyle}
                        required
                    />
                    {/* State */}
                    <input
                        type="text"
                        placeholder="State (Required)"
                        value={this.state.state || ''}
                        onChange={(e) => this.setState({ state: (e.target as HTMLInputElement).value }, () => this.allFieldsAreValid())}
                        style={inputFieldStyle}
                        required
                    />
                    {/* Zip Code */}
                    <input
                        type="text"
                        placeholder="Zip Code (Required)"
                        value={this.state.zip || ''}
                        onChange={(e) => this.setState({ zip: (e.target as HTMLInputElement).value }, () => this.allFieldsAreValid())}
                        style={inputFieldStyle}
                        required
                    />
                </div>
            </div>
        );
    };
    

    setIndividualShip = (turnOn: boolean) => {
        this.setState({ individualShip: turnOn })
    }

    getIndividualShipSection = () => {
        var editDisabled = this.props.purchaseComplete || this.state.purchaseComplete;
        // CED always ships to a provided address — always show the address form
        if (this.props.tvite.specialWebstore === 'CED') {
            return this.directShipContent();
        }
        if (this.props.tvite.shipType == Tgcc.ShipmentTypes.Select) {
            var shipContent = this.state.individualShip ? this.directShipContent() : this.freeShipContent();
            return (
                <div>
                    <div style={hdrStyle}>Choose your shipping:</div>
                    <div style={checkRowStyle}>
                        <div style={checkLabelStyle}>Bulk Shipping</div>
                        <div style={checkLabelStyle}>Individual</div>
                    </div>
                    <div style={checkRowStyle}>
                        <input style={shipCheckStyle} type="checkbox" checked={!this.state.individualShip} onChange={() => this.setIndividualShip(false)} disabled={editDisabled} />
                        <input style={shipCheckStyle} type="checkbox" checked={this.state.individualShip} onChange={() => this.setIndividualShip(true)} disabled={editDisabled} />
                    </div>
                    {shipContent}
                </div>
            )
        } else if (this.props.tvite.shipType == Tgcc.ShipmentTypes.Individual) {
            return this.directShipContent();
        } else {
            return this.freeShipContent();
        }
    }

    getYouthSizes() {
        const completed = this.props.purchaseComplete || this.state.purchaseComplete;
        const youthSizes = [
            { size: 'YXSmall', label: 'Youth X-Small' },
            { size: 'YSmall', label: 'Youth Small' },
            { size: 'YMedium', label: 'Youth Medium' },
            { size: 'YLarge', label: 'Youth Large' },
            { size: 'YXLarge', label: 'Youth X-Large' },
        ];
    
        if (this.props.tvite.youthSizes) {
            const isCed = this.props.tvite.specialWebstore === 'CED';
            return (
                <div style={sizeOptionContainerStyle}>
                    <div style={sizeHeaderStyle}>Youth Sizes</div>
                    <div style={sizeRowStyle} className='sizeRow'>
                        {youthSizes.map(({ size, label }) => (
                            <div style={sizeCardContainerStyle} id='sizeCardContainer' key={size}>
                                {isCed ? (
                                    <CedBreakerSizeCard
                                        size={size}
                                        displayLabel={label}
                                        value={this.state[size]}
                                        onChange={this.handleFieldChange}
                                        disabled={completed}
                                    />
                                ) : (
                                    <SizeCard
                                        size={size}
                                        displayLabel={label}
                                        value={this.state[size]}
                                        onChange={this.handleFieldChange}
                                        disabled={completed}
                                        specialWebstore={this.props.tvite.specialWebstore}
                                        style={updatedSizeCardStyle}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
    }
    
    getAdultSizes() {
        const completed = this.props.purchaseComplete || this.state.purchaseComplete;
        // Define adult sizes excluding 4XL for HBI
        let adultSizes = [
            { size: 'Small', label: 'Small' },
            { size: 'Medium', label: 'Medium' },
            { size: 'Large', label: 'Large' },
            { size: 'XLarge', label: 'XLarge' },
            { size: 'XXL', label: '2XLarge' },
            { size: 'XXXL', label: '3XLarge' },
        ];
    
        // Exclude 4XL if the special webstore is HBI
        if (this.props.tvite.specialWebstore !== 'HBI') {
            adultSizes.push({ size: 'XXXXL', label: '4XLarge' });
        }
        // CED: 5XL with +$3 surcharge (shown on SizeCard)
        if (this.props.tvite.specialWebstore === 'CED') {
            adultSizes.push({ size: 'XXXXXL', label: '5XLarge' });
        }
    
        const isCed = this.props.tvite.specialWebstore === 'CED';
        return (
            <div style={sizeOptionContainerStyle}>
                <div style={sizeHeaderStyle}>Adult Sizes</div>
                {this.props.tvite.specialWebstore === 'HBI' && (
                    <div style={{ textAlign: 'center', margin: '10px', fontSize: '16px', color: 'red' }}>
                        Limit of 1 shirt per customer
                    </div>
                )}

                <div style={sizeRowStyle} className='sizeRow'>
                    {adultSizes.map(({ size, label }) => (
                        <div style={sizeCardContainerStyle} key={size}>
                            {isCed ? (
                                <CedBreakerSizeCard
                                    size={size}
                                    displayLabel={label}
                                    value={this.state[size]}
                                    onChange={this.handleFieldChange}
                                    disabled={completed}
                                />
                            ) : (
                                <SizeCard
                                    size={size}
                                    displayLabel={label}
                                    value={this.state[size]}
                                    onChange={this.handleFieldChange}
                                    disabled={completed}
                                    specialWebstore={this.props.tvite.specialWebstore}
                                    style={updatedSizeCardStyle}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderSingleSizeItem() {
        // For WO773171 and WO773246, hide the quantity section
        if (this.props.tvite.proofId === 'WO773171' || this.props.tvite.proofId === 'WO773246') {
            return null; // Don't render the single size item section
        }
        
        return (
            <div style={{
                ...sizeOptionContainerStyle, // Use the container style for consistency
                backgroundColor: '#f7f7f7', // A light background to distinguish the section
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Soft shadow for depth
                padding: '20px',
                borderRadius: '10px', // Rounded corners
                margin: '20px 0', // Space above and below
            }}>
                <h2 style={{
                    ...shipHdrStyle, // Reuse the shipping header style for consistency
                    marginBottom: '15px', // Space below the header
                }}>
                    'One Size' Item Quantity
                </h2>
                <p style={{
                    ...proseStyle, // Reuse the prose style for text
                    fontSize: '16px', // Slightly larger font size for readability
                    color: '#333', // Dark text for contrast
                }}>
                    This item is available in one size only. Please specify the quantity you wish to order and proceed to checkout.
                </p>
                <input
                    type="number"
                    value={this.state.singleItemQuantity}
                    onChange={this.handleSingleItemQuantityChange}
                    min="1"
                    style={{
                        ...inputFieldStyle, // Reuse the input field style for consistency
                        marginTop: '10px', // Space above the input field
                        width: '100%', // Full width within the container
                        maxWidth: '200px', // Better mobile width for single size input
                    }}
                />
            </div>
        );
    }
    
handleSingleItemQuantityChange = (event) => {
    const quantity = parseInt(event.target.value, 10) || 0;
    this.setState({ singleItemQuantity: quantity }, () => {
        // Trigger a validation check after state update if necessary
        this.allFieldsAreValid();
    });
};
    
// Method to render size options if the item is NOT a single size item
      renderSizeOptions() {
      // For WO773171 and WO773246, hide the quantity section and set quantity to 1
      if (this.props.tvite.proofId === 'WO773171' || this.props.tvite.proofId === 'WO773246') {
        return null; // Don't render any size options
      }
      
      return (
        <div>
          {this.getAdultSizes()}
          {this.getYouthSizes()}
        </div>
      );
    }

    orderFailed = (err) => {
        this.cedProcessingStartedAt = null;
        if (this.cedOrderCompleteTimer != null) {
            window.clearTimeout(this.cedOrderCompleteTimer);
            this.cedOrderCompleteTimer = null;
        }
        this.setState({ error: err, isWaiting: false, cedPickedStamp: false });
    }

    render() {
        if (!this.props.tvite) {
            return Tgcc.workingGif;
        }
    
        if (this.props.tvite.status === 'CLOSED') {
            return <div style={closedBtn}>Sorry, this T-Vite is now closed</div>;
        }
    
        const totalCt: number = this.state.isSingleSizeItem
            ? (this.state.singleItemQuantity || 0)
            : this.getTotalCount();
        const price: number = this.props.tvite.price;
        const total: number = (totalCt * price) + this.getSizeSurchargeTotal();
    
        const completed = this.props.purchaseComplete || this.state.purchaseComplete;
        // For WO773171 and WO773246, always consider quantity as valid (1)
        const isQuantityValid = (this.props.tvite.proofId === 'WO773171' || this.props.tvite.proofId === 'WO773246') ? true : (this.state.isSingleSizeItem ? this.state.singleItemQuantity > 0 : totalCt > 0);
        const shippingReady = !this.requiresShippingAddress()
            || (!this.isBlank(this.state.address1) && !this.isBlank(this.state.city) && !this.isBlank(this.state.state) && !this.isBlank(this.state.zip));
        const isCed = this.props.tvite.specialWebstore === 'CED';
        const locationReady = !this.isBlank(this.state.Organization);
        const canBuy = !completed && !this.state.error && this.state.FirstName && this.state.LastName && this.state.Email && isQuantityValid && shippingReady
            && (!isCed || locationReady);
    
        const buyButtnStyle = canBuy && !this.state.isWaiting && !this.state.cedPickedStamp
            ? orderBtn
            : { ...orderBtn, opacity: 0.5, pointerEvents: 'none' as const };
        let buyButton;
        if (completed) {
            buyButton = (
                <div style={thanksStyle}>
                    Thank you!
                    <img src={Tgcc.ResolveUrl('~/images/TviteConfirmationImage.png')} alt="Thank you image" style={imageStyle} />
                </div>
            );
        } else {
            buyButton = (
                <div
                    style={buyButtnStyle}
                    onClick={canBuy && !this.state.isWaiting && !this.state.cedPickedStamp ? this.buyNow : undefined}
                    role="button"
                    aria-busy={isCed && (this.state.isWaiting || this.state.cedPickedStamp) ? true : undefined}
                >
                    {isCed ? '⚡ Place your order' : 'Place your order'}
                </div>
            );
        }
    
        const error = completed ? (
            <div style={errorStyle}>Order Received</div>
        ) : this.state.error ? (
            <div style={errorStyle}>{this.state.error}</div>
        ) : (
            <div style={errorStyle}></div>
        );

        const nameReady = !this.isBlank(this.state.FirstName) && !this.isBlank(this.state.LastName);
        const emailReady = !this.isBlank(this.state.Email) && this.emailIsValid();
        const addressReady = !this.isBlank(this.state.address1)
            && !this.isBlank(this.state.city)
            && !this.isBlank(this.state.state)
            && !this.isBlank(this.state.zip);

        const checkoutInner = (
            <React.Fragment>
            {this.state.showThankYouPopup && (
                <ThankYouPopup
                    onClose={this.closeThankYouPopup}
                    specialWebstore={this.props.tvite.specialWebstore}
                    catalogUrl={this.props.tvite.catalogUrl}
                />
            )}
            {/* Overlay only during API/processing phase — not during the PICKED stamp beat */}
            {isCed
                && !this.state.showThankYouPopup
                && !completed
                && this.state.isWaiting
                && <CedOrderProcessing />}
            <div id="userInfoContainer" style={isCed ? { ...userInfoContainer, backgroundColor: NAVY_CED } : userInfoContainer}>
                    <h1 style={headerStyle}>Your Information</h1>
                    {this.props.tvite.proofId !== 'WO773171' && this.props.tvite.proofId !== 'WO773246' && (
                        <h2 style={subheaderStyle}>
                            {this.state.subheaderText}
                        </h2>
                    )}
                    {isCed && (
                        <CedFieldPowerMeter
                            nameReady={nameReady}
                            emailReady={emailReady}
                            locationReady={locationReady}
                            addressReady={addressReady}
                        />
                    )}
                    <div style={userInfoContent}>
                        <div style={userInfoRowStyle}>
                            <input type="text" id="FirstName" name="FirstName" placeholder="First Name (Required)" style={userInfoInputStyle} className='userInput' onChange={this.handleFieldChange} value={this.state.FirstName} disabled={completed} required />
                        </div>
                        <div style={userInfoRowStyle}>
                            <input type="text" id="LastName" name="LastName" placeholder="Last Name (Required)" style={userInfoInputStyle} className='userInput' onChange={this.handleFieldChange} value={this.state.LastName} disabled={completed} required />
                        </div>
                        <div style={userInfoRowStyle}>
                            <input type="email" id="Email" name="Email" placeholder="Email Address (Required)" style={userInfoInputStyle} className='userInput' onChange={this.handleFieldChange} value={this.state.Email} disabled={completed} required />
                        </div>
                        {this.props.tvite.specialWebstore === 'PapaJohns' && (
                        <div style={userInfoRowStyle}>
                            <input type="text" id="PhoneNumber" name="PhoneNumber" placeholder="Phone Number" style={userInfoInputStyle} className='userInput' onChange={this.handleFieldChange} value={this.state.PhoneNumber} disabled={completed} />
                        </div>
                    )}
                        <div style={userInfoRowStyle}>
                            <input
                                type="text"
                                id="Organization"
                                name="Organization"
                                placeholder={
                                    this.props.tvite.specialWebstore === 'CED'
                                        ? 'CED Location (Required)'
                                        : this.props.tvite.proofId === 'WO748640'
                                            ? 'Company (Required)'
                                            : 'Company (Optional)'
                                }
                                style={userInfoInputStyle}
                                className='userInput'
                                onChange={this.handleFieldChange}
                                value={this.state.Organization}
                                disabled={completed}
                                required={this.props.tvite.specialWebstore === 'CED' || this.props.tvite.proofId === 'WO748640'}
                            />
                        </div>
                    </div>
                </div>
    
                {this.getIndividualShipSection()}
                {this.state.isSingleSizeItem ? this.renderSingleSizeItem() : this.renderSizeOptions()}
    
                <hr style={hrStyle} />
                {error}
                {isCed && !completed && (
                    <CedPickTicket
                        lines={this.getCedPickLines()}
                        total={total}
                        unitPrice={price}
                        stamped={this.state.cedPickedStamp}
                    />
                )}
                <div style={{
                    display: 'flex',
                    minHeight: 50,
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                }}>
                    {buyButton}
                </div>
            </React.Fragment>
        );

        if (isCed) {
            return (
                <CedCheckoutShell style={checkoutContainer} className="tbankerCheckOut">
                    {checkoutInner}
                </CedCheckoutShell>
            );
        }

        return (
            <div style={checkoutContainer} className="tbankerCheckOut">
                {checkoutInner}
            </div>
        );
    }
}
